// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function incentive_parameters_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var completed_trips = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "completed_trips"), null));
  if (completed_trips.TAG === /* Ok */0) {
    var abrtg_allowed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "abrtg_allowed"), null));
    if (abrtg_allowed.TAG === /* Ok */0) {
      var missed_order_allowed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "missed_order_allowed"), null));
      if (missed_order_allowed.TAG === /* Ok */0) {
        var fraud_allowed = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "fraud_allowed"), null));
        if (fraud_allowed.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    completed_trips: completed_trips._0,
                    abrtg_allowed: abrtg_allowed._0,
                    missed_order_allowed: missed_order_allowed._0,
                    fraud_allowed: fraud_allowed._0
                  }
                };
        }
        var e = fraud_allowed._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".fraud_allowed" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = missed_order_allowed._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".missed_order_allowed" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = abrtg_allowed._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".abrtg_allowed" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = completed_trips._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".completed_trips" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function campaign_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var campaign_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "campaign_id"), null));
  if (campaign_id.TAG === /* Ok */0) {
    var start_date = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_date"), null));
    if (start_date.TAG === /* Ok */0) {
      var end_date = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_date"), null));
      if (end_date.TAG === /* Ok */0) {
        var incentive_parameters = incentive_parameters_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "incentive_parameters"), null));
        if (incentive_parameters.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: {
                    campaign_id: campaign_id._0,
                    start_date: start_date._0,
                    end_date: end_date._0,
                    incentive_parameters: incentive_parameters._0
                  }
                };
        }
        var e = incentive_parameters._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".incentive_parameters" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = end_date._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".end_date" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = start_date._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".start_date" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  var e$3 = campaign_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".campaign_id" + e$3.path,
            message: e$3.message,
            value: e$3.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var campaigns = Decco.listFromJson(campaign_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "campaigns"), null));
  if (campaigns.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              campaigns: campaigns._0
            }
          };
  }
  var e = campaigns._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".campaigns" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  incentive_parameters_decode ,
  campaign_decode ,
  t_decode ,
  
}
/* No side effect */
